define('components/popin/views/PopinView', [
    'components/popin/templates/popin',
    'components/popin/templates/expand',
    'components/ecrinbridge/EcrinBridge'
], function(popinTpl, expandTpl, EcrinBridge) {

    var PopinView = Mazarine.View.extend({

        events: function() {
            var events = {
                "click .js-maz-overlay": "onClickOverlay",
                "click .js-maz-close": "onClickClose",
                "click .maz-btn-go-top": "onClickBackToTop"
            };
            if (typeof this.interceptTouchEvent === "function") {
                _.extend(events, {
                    "touchstart.maz-dior .js-maz-close": "onClickClose",
                });
            }
            return events;
        },

        /*
         * This function select the correct template, and then call the render function.
         */
        initialize: function(options) {
            if (this.model.get('popinType') === "popin") {
                this.template = popinTpl;
            } else if (this.model.get('popinType') === "expand") {
                this.template = expandTpl;
            }

            this.listenTo(this.model, 'change:view', this.render);
            this.render();
        },

        /*
         * This function render the view of the popin, and the view on the popin.
         * It takes a lot of differents options described in the PopinModel
         */
        render: function() {
            if( this.model.get('animation') ) {
                console.log('%c[Animation] closed -> before ', 'background: lightgreen; color: white');
                this.$el.removeClass('maz-popin-closed maz-popin-closing maz-popin-opening maz-popin-opened').addClass('maz-popin-before');
            }

            this.$el.html(this.template(this.model.toJSON()));
            this.$el.addClass('maz-' + this.model.get('popinType') + '-container');
            $(this.model.get('attach')).append(this.$el);
            this.$('.maz-' + this.model.get('popinType') + '-content').prepend(this.model.get('view').render().$el);

            $('html').addClass('maz-' + this.model.get('popinType') + '-opened');

            if (this.model.get('view') && this.model.get('view').model) {
                var onContentReady = _.once(this.onContentReady);

                if( this.model.get('view').model.get('isReady') ) {
                    _.delay(_.bind(onContentReady, this), 40);
                } else {
                    _.delay(_.bind(onContentReady, this), 4000);

                    this.listenTo(this.model.get('view').model, 'change:isReady', _.bind( onContentReady, this ) );
                }
            }

            if( this.model.get('popinScrollMode') === "external" ) {
                $('.maz-popin-wrapper').on('scroll', _.bind( this.onScroll, this ) );
            }

            if (_.isFunction(this.model.get('view').afterRender)) {
                this.model.get('view').afterRender();
            }
            if (_.isFunction(this.model.get('onContentRendered'))) {
                this.model.get('onContentRendered')();
            }
            if (this.model.get('popinScrollMode') === "external") {
                this.resizeOverlay();
                var throttledResizeOverlay = _.throttle(this.resizeOverlay, 500);
                $(window).on('resize', throttledResizeOverlay);
            }
            if (this.model.get('popinScrollMode') === "internal" && this.$('.maz-popin-header').length) {
                this.resizeContent();
                var throttledResizeContent = _.throttle(this.resizeContent, 500);
                $(window).on('resize', throttledResizeContent);
            }

            this.model.set('open', true);
            this.delegateEvents();
        },

        /*
         * This function is called juste before the close of the popin.
         * And allow you to do something in the onBeforeCloseCallback before really closing the popin.
         */
        beforeClose: function( isManual) {
            var callback = this.model.get('onBeforeCloseCallback');

            if (callback) {
                callback(_.bind(function(){
                    this.close( isManual );
                }, this));
            } else {
                this.close( isManual );
            }
        },

        /*
         * This function close the popin eventually with animation, and then remove the content.
         */
        close: function( isManual ) {
            if( this.model.get('animation') ) {
                this.$el.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
                this.$el.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', _.bind(function(e) {
                    this.removeContent( isManual );
                    console.log('%c[Animation] closing -> closed ', 'background: lightgreen; color: white');
                    this.$el.removeClass('maz-popin-closing maz-popin-opened maz-popin-opening').addClass('maz-popin-closed');
                }, this) );

                console.log('%c[Animation] opened -> closing ', 'background: lightgreen; color: white');
                this.$el.removeClass('maz-popin-opened').addClass('maz-popin-closing');
            } else {
                this.removeContent( isManual );
            }
        },

        /*
         * This function remove the view of the popin.
         * And then close the popin.
         */
        removeContent: function( isManual ) {
            console.log("[PopinView -> removeContent]", isManual);
            if (_.isFunction( this.model.get('view').onRemove)) {
                this.model.get('view').onRemove();
            }

            var callback = this.model.get('onCloseCallback');
            if (callback) {
                callback();
            }

            var manualCloseCallback = this.model.get('onManualCloseCallback');
            if (isManual && manualCloseCallback) {
                manualCloseCallback();
            }

            this.stopListening(this.model.get('view').model);

            if( isManual ) {
                this.$el.remove();
                $('html').removeClass('maz-' + this.model.get('popinType') + '-opened');
            }
            this.model.set('open', false);
        },

        /*
         * This function handle the click on the overlay.
         * Then it call the beforeClose function.
         */
        onClickOverlay: function(e) {
            e.preventDefault();
            this.beforeClose(true);
        },

        /*
         * This function handle the click on the close button.
         * Then it call the beforeClose function.
         */
        onClickClose: function(e) {
            if (typeof this.interceptTouchEvent === "function") {
                this.interceptTouchEvent(e, _.bind(function(){
                    this.beforeClose(true);
                }, this));
            } else {
                e.preventDefault();
                this.beforeClose(true);
            }
        },

        /*
         * This function handle the click on the backToTop button, and then scroll to the top of the body, or the top of the popin container according to the scroll mode
         */
        onClickBackToTop: function() {
            if (this.model.get('popinScrollMode') === "external") {
                this.$('.maz-' + this.model.get('popinType') + '-wrapper').animate({
                    scrollTop: 0
                }, 500);
            } else if (this.model.get('popinScrollMode') === "internal") {
                this.$('.maz-' + this.model.get('popinType') + '-content').animate({
                    scrollTop: 0
                }, 500);
            } else if (this.model.get('popinScrollMode') === "native") {
                EcrinBridge.showHeader(true, true);
            }
        },

        /*
         * Function called when the content of the popin is ready
         * This function called the onContentReadyCallback callback
         */
        onContentReady: function() {
            if( this.model.get('animation') ) {
                this.$el.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
                this.$el.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', _.bind(function(e) {
                    if( this.$el.hasClass('maz-popin-opening') ) {
                        console.log('%c[Animation] opening -> opened ', 'background: lightgreen; color: white');
                        this.$el.removeClass('maz-popin-opening').addClass('maz-popin-opened');
                    }
                }, this) );

                console.log('%c[Animation] before -> opening ', 'background: lightgreen; color: white');
                this.$el.removeClass('maz-popin-before').addClass('maz-popin-opening');
            }

            if (this.model.get('popinScrollMode') === "external") {
                this.resizeOverlay();
            }
            if (this.model.get('popinScrollMode') === "internal" && this.$('.maz-popin-header').length) {
                this.resizeContent();
            }

            var callback = this.model.get('onContentReadyCallback');

            if (_.isFunction(callback)) {
                callback();
            }
        },

        /*
         * This function resize the overlay with the height of the content
         */
        resizeOverlay: function() {
            this.$('.maz-overlay').height(this.$('.maz-popin').outerHeight(true));
        },

        /*
         * This function resize the content with the height of the popin minus the size of the header
         */
        resizeContent: function() {
            this.$('.maz-popin-content').css('height', (this.$('.maz-popin').height() - this.$('.maz-popin-header').outerHeight(true)) + 'px');
        },

        /*
         * This function call the onEnter function of the view of the content
         */
        onEnter: function() {
            if (_.isFunction(this.model.get('view').onEnter)) {
                this.model.get('view').onEnter();
            }
        },

        /*
         * This function call the onLeave function of the view of the content
         */
        onLeave: function() {
            if (_.isFunction(this.model.get('view').onLeave)) {
                this.model.get('view').onLeave();
            }
        },

        /*
         * This function call the onScroll function of the view of the content
         */
        onScroll: function( e ) {
            if( this.model.get('view').onScroll ) {
                this.model.get('view').onScroll( $(e.currentTarget).scrollTop() );
            }
        }
    });

    return PopinView;
});
